import React, { useState, useEffect } from "react"
import CreateableAutocompleteDropdown from '../components/CreateableAutocompleteDropdown'
import { Button, Alert, TextField } from '@mui/material'
import styles from './Login.module.scss'
import axios from "axios"

export default function Signup() {
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [company, setCompany] = useState(null)
    const [isError, setIsError] = useState(false)
    const [info, setInfo] = useState('')
    const [companyNames, setCompanyNames] = useState([])

    //email format with 3 letters or more
    const emailValidation = () => {
      return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email)
    }

    useEffect(() => {
        axios.get(`api/getCompanyNames`)
        .then(res => res.data)
        .then(res => setCompanyNames(res.company))
        return () => {}
    }, []) // eslint-disable-line

    const postSignup = (event) => {
        event.preventDefault()
        if(!emailValidation() || !firstName || !lastName || !company){
            return setIsError(true)
        }
        setIsError(false)
        // fetch('/api/users/register', {
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({first_name: firstName, last_name: lastName, email, company })
        // })
        axios({
            method: 'post',
            url: '/api/users/register',
            data: {first_name: firstName, last_name: lastName, email, company }
        }).then(result => {
            if (result.status === 200) {
                setInfo(result.data.result)
            } else {
                setIsError(true)
                setInfo(result.data.result)
            }
        }).catch(e => {
            setIsError(true)
        })
    }

    return (
        <div className={styles['loginCard']}>
            <form className={styles['form']} onSubmit={postSignup}>
                <TextField
                    value={firstName}
                    placeholder="First Name"
                    onChange={e => { setFirstName(e.target.value) }}
                    type="text"
                    variant="outlined"
                />
                <TextField
                    value={lastName}
                    placeholder="Last Name"
                    onChange={e => { setLastName(e.target.value) }}
                    type="text"
                    variant="outlined"
                />
                <TextField
                    value={email}
                    placeholder="Email"
                    onChange={e => { setEmail(e.target.value) }}
                    type="email"
                    variant="outlined"
                />
                <CreateableAutocompleteDropdown dropdownOptions={companyNames} value={company} setValue={setCompany} placeholder="Company name" />
                <Button type="submit" color="primary" variant="contained">Sign Up</Button>
                { isError && !info && <Alert severity="error">Could not sign up!</Alert> }
                { info && <Alert severity={isError?"error":"success"}>{info}</Alert>}
            </form>
        </div>
    )
}
